<template>
    <div id="types" class="flex-x-center m-row">
        <Section
            v-for="(section, s) in Levels()"
            :key="s"
            :types="section"
            :totalLevels="TotalLevels()"
            :contentInitiated="contentInitiated"
            :mobile="mobile"
            @content-initiated="$emit('content-initiated', $event)"
        />
    </div>
</template>

<script>
import Section from "@/components/Projects/Project/Detail/Types/Section.vue";
import { projectModel } from "@/models";

export default {
    name: "ProjectDetailTypes",
    props: {
        types: Array,
        contentInitiated: Boolean,
        mobile: Boolean
    },
    components: { Section },
    methods: {
        TotalLevels: function() {
            return this.types[this.types.length - 1].Level;
        },

        // Assigns levels and list of names associated with them
        Levels: function() {
            const levels = [];
            for (let l = 0; l < this.TotalLevels(); l++) {
                const level = this.types.filter(t => t.Level === l + 1);
                const typeNames = [];
                for (const type of level) {
                    typeNames.push(type.Name);
                }
                levels[l] = {
                    level: l + 1,
                    names: typeNames
                };
            }
            return levels;
        }

    },
    beforeMount: function() { this.Levels(); },
    emits: [ ...projectModel.emits ]
};
</script>